import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MoveDown } from "lucide-react";

import sortByDate from "../../functions/sorting/arrowSorting/sortByDate";
import sortByAlphabetically from "../../functions/sorting/arrowSorting/sortByAlphabetically";
import sortByNumber from "../../functions/sorting/arrowSorting/sortByNumber";
import { updateData } from "../../redux/dataSlice";
import { setSortStatus } from "../../redux/dataSlice";

const ArrowSorting = ({ sortBy, address, arrowColor, arrowSize }) => {
  const dispatch = useDispatch();
  const [isArrowToggled, setIsArrowToggled] = useState(false);
  const data = useSelector((state) => state.data.data);

  // const handleSorting = () => {
  //   dispatch(setSortStatus(true));
  //   setIsArrowToggled((prev) => {
  //     const newToggle = !prev;

  //     if (sortBy === "date") {
  //       dispatch(updateData(sortByDate(data, newToggle, address)));
  //     } else if (sortBy === "alphabetically") {
  //       dispatch(updateData(sortByAlphabetically(data, newToggle, address)));
  //     } else if (sortBy === "number") {
  //       dispatch(updateData(sortByNumber(data, newToggle, address)));
  //     }

  //     return newToggle;
  //   });
  // };

  const handleSorting = () => {
    const newToggle = !isArrowToggled;
    setIsArrowToggled(newToggle);
    dispatch(setSortStatus(true));

    if (sortBy === "date") {
      dispatch(updateData(sortByDate(data, newToggle, address)));
    } else if (sortBy === "alphabetically") {
      dispatch(updateData(sortByAlphabetically(data, newToggle, address)));
    } else if (sortBy === "number") {
      dispatch(updateData(sortByNumber(data, newToggle, address)));
    }
  };

  return (
    <MoveDown
      className={`cursor-pointer px-1 ${isArrowToggled ? "rotate-180" : ""}`}
      onClick={handleSorting}
      size={arrowSize ?? 18}
      color={arrowColor ?? "white"}
    />
  );
};

export default ArrowSorting;
